import type { ServiceOpportunity } from './schemas';

export const canCounterServiceOffer = (opportunity: ServiceOpportunity | null | undefined) =>
  opportunity != null &&
  ['NEGOTIATING', 'PENDING_ACCEPTANCE'].includes(opportunity.status) &&
  opportunity.turn === 'YOUR_TURN' &&
  opportunity.availableActions.includes('counter') &&
  opportunity.latestNegotiation != null;

export const canAcceptServiceOffer = (opportunity: ServiceOpportunity | null | undefined) =>
  opportunity != null &&
  ['NEGOTIATING', 'PENDING_ACCEPTANCE'].includes(opportunity.status) &&
  opportunity.turn === 'YOUR_TURN' &&
  opportunity.availableActions.includes('accept') &&
  opportunity.latestNegotiation?.selectionStatus === 'RECORDED' &&
  opportunity.latestNegotiation.availabilitySelection.length > 0;
